import { supabase } from "@/lib/supabaseClient";
import { ensureAuthenticatedSession } from "@/utils/authentication";

const BUCKET_NAME = "barrio-hub-manager";
const DEFAULT_EXPIRATION_SECONDS = 60 * 10;

const sanitizeStoragePath = (rawPath: string): string => {
  const trimmed = `${rawPath ?? ""}`.trim();
  if (!trimmed) {
    throw new Error("La ruta del recurso de la novedad es obligatoria.");
  }

  const withoutLeadingSlashes = trimmed.replace(/^\/+/, "");
  const bucketPrefix = `${BUCKET_NAME}/`;
  if (withoutLeadingSlashes.startsWith(bucketPrefix)) {
    return withoutLeadingSlashes.slice(bucketPrefix.length);
  }

  return withoutLeadingSlashes;
};

export const getChangelogPreviewUrl = async (
  storagePath: string,
  expiresInSeconds = DEFAULT_EXPIRATION_SECONDS
): Promise<string> => {
  const normalizedPath = sanitizeStoragePath(storagePath);
  await ensureAuthenticatedSession();

  const { data, error } = await supabase.storage
    .from(BUCKET_NAME)
    .createSignedUrl(normalizedPath, expiresInSeconds);

  if (error || !data?.signedUrl) {
    const message = error?.message ?? "No se pudo cargar la vista previa de la novedad.";
    throw new Error(message);
  }

  return data.signedUrl;
};
